import React from 'react';
import { Link } from 'react-router-dom';
import './notfound.scss'
const NotFound = () => {
  return (
    <div className="">
      <div className="">
        <div className="p-8">
          
          
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-3">Page Not Found</h1>
            <p className="text-lg text-gray-600 max-w-md mx-auto">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link 
              to="/" 
              className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-opacity-50"
            >
              Go to Login
            </Link>
            
          
          </div>
        </div>
        
       
      </div>
    </div>
  );
};

export default NotFound;